import i18n from '@/locales'

const YESTERDAY = i18n.t('page_shift_model_last_day')
const TODAY = i18n.t('page_shift_model_today')
const TOMORROW = i18n.t('page_shift_model_next_day')

const transform = (t: number): string => {
  return t >= 10 ? String(t) : '0' + t
}

export const format = (time: number, head = true) => {
  const h = Number.parseInt(String(time / 60), 10)
  const m = time % 60
  if (h < 0) {
    let realH: string
    let realM: string
    if (m === 0) {
      realH = transform(h + 24)
      realM = '00'
    } else {
      realH = transform(h + 24 - 1)
      realM = transform(m + 60)
    }
    return `${head ? `${YESTERDAY} ` : ''}${realH}:${realM}`
  } else if (h === 0) {
    return m < 0
      ? `${head ? `${YESTERDAY} ` : ''}23:${transform(m + 60)}`
      : `${head ? `${TODAY} ` : ''}00:${transform(m)}`
  } else if (h < 24) {
    return `${head ? `${TODAY} ` : ''}${transform(h)}:${transform(m)}`
  } else {
    return `${head ? `${TOMORROW} ` : ''}${transform(h - 24)}:${transform(m)}`
  }
}
